import { Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TitleLibComponent } from '../../title/title.component';
import { ButtonLibComponent } from '../../button/button.component';
import { SafeHtmlLibComponent } from '../../safe-html/safe-html.component';

/**
 * Componente atom para exibir o conteúdo do modal de instruções do profile.
 *
 * Este componente é renderizado dinamicamente dentro do modal através de ComponentOutlet.
 * Exibe um título, subtítulo e uma lista de passos com checkmarks.
 *
 * @example
 * <lib-profile-modal-content
 *   [title]="'Como conectar seu carro?'"
 *   [subtitle]="'Veja como é rápido e simples.'"
 *   [steps]="steps"
 * />
 */
@Component({
  standalone: true,
  selector: 'lib-profile-modal-content',
  imports: [
    TranslateModule,
    TitleLibComponent,
    ButtonLibComponent,
    SafeHtmlLibComponent
  ],
  templateUrl: './profile-modal-content.component.html',
  styleUrls: ['./profile-modal-content.component.scss'],
})
export class ProfileModalContentLibComponent {
  /**
   * Título principal do modal
   * Exemplo: "Como conectar seu carro?"
   */
  title = input.required<string>();

  /**
   * Subtítulo/descrição inicial
   * Exemplo: "Veja como é rápido e simples."
   */
  subtitle = input<string>('');

  /**
   * Lista de passos a serem exibidos
   * Cada passo pode conter texto simples ou HTML com formatação
   */
  steps = input.required<string[]>();

  /**
   * Texto do botão de ação (opcional)
   * Se não informado, usa "Entendi" como padrão
   */
  buttonText = input.required<string>();

  /**
   * Fecha o modal ao clicar no botão de ação
   */
  protected buttonClick = output<void>();
}
